module.exports = __webpack_public_path__ + "static/media/twitter.e5bea400.svg";